import Vue from 'vue'
import VuePageTitle from 'vue-page-title'
import App from './App.vue'
import router from './router'
import store from './store'
import NProgress from 'vue-nprogress'
import VueLayers from 'vuelayers'
import Vuelidate from 'vuelidate'
import VueMoney from 'v-money'
import VueTheMask from 'vue-the-mask'
import VueClipboard from 'vue-clipboard2'
import vSelect from 'vue-select'
import { Auth0Plugin } from './plugins/auth'

import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

Sentry.init({
    dsn: 'https://c8ba1f66e77549dc97741c63e2e519f1@o332361.ingest.sentry.io/5241696',
    integrations: [new VueIntegration({ Vue, attachProps: true })],
});

import {
    InputNumber,
    Message,
    Upload,
    Button,
    Layout,
    Table,
    Icon,
    Radio,
    Dropdown,
    Menu,
    Input,
    Form,
    Tooltip,
    Select,
    Switch,
    DatePicker,
    Tag,
    Spin,
    Checkbox,
    Tabs,
    Pagination,
    notification,
    Card,
    Popover,
    Row,
    Col,
    Modal,
    message,
    Popconfirm,
    Alert,
    Badge,
    Avatar,
} from 'ant-design-vue'

import './global.scss'
import './tailwind.css'


// Import the Auth0 configuration
import { domain, clientId, audience } from './auth_config.json'

Vue.use(VueTheMask)
Vue.use(VueMoney, { precision: 4 })
Vue.use(VueLayers)
Vue.use(DatePicker)
Vue.use(Popconfirm)
Vue.use(Badge)
Vue.use(Modal)
Vue.use(Avatar)
Vue.use(Row)
Vue.use(Col)
Vue.use(Popover)
Vue.use(Card)
Vue.use(Button)
Vue.use(Layout)
Vue.use(Table)
Vue.use(Icon)
Vue.use(Radio)
Vue.use(Dropdown)
Vue.use(Menu)
Vue.use(Input)
Vue.use(Form)
Vue.use(Tooltip)
Vue.use(Select)
Vue.use(Tag)
Vue.use(Spin)
Vue.use(Checkbox)
Vue.use(Tabs)
Vue.use(Pagination)
Vue.use(Upload)
Vue.use(Message)
Vue.use(InputNumber)
Vue.use(Switch)
Vue.use(Alert)

// clipboard plugin
Vue.use(VueClipboard)

Vue.prototype.$notification = notification
Vue.prototype.$message = message

Vue.use(Auth0Plugin, {
    domain,
    clientId,
    audience,
    onRedirectCallback: appState => {
        router.push(
            appState && appState.targetUrl ?
            appState.targetUrl :
            window.location.pathname
        )
    },
})

Vue.use(Vuelidate)

Vue.use(NProgress)
    // Vue.use(FirebaseAuthService)
Vue.use(VuePageTitle, {
    prefix: 'KiwiCheckout | ',
    router,
})

import KInput from './components/v2/ui/Input'
Vue.component('v-select', vSelect)
Vue.component('k-input', KInput)

Vue.config.productionTip = false
const nprogress = new NProgress({ parent: 'body' })

new Vue({
    router,
    store,
    nprogress,
    render: h => h(App),
}).$mount('#app')